import { styled } from '@mui/system'
import { Box } from '@mui/material'

export const LoaderWrapper = styled(Box)(`
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    & b {
        font-size: 14px;
        font-weight: 600; // 500;
    }
`)

export const Loader = styled(Box)(`
    margin-top: -15px;
    &.load-3 .line:nth-last-of-type(1) { animation: loadingC 0.6s 0.1s linear infinite; }
    &.load-3 .line:nth-last-of-type(2) { animation: loadingC 0.6s 0.2s linear infinite; margin:0 3px; }
    &.load-3 .line:nth-last-of-type(3) { animation: loadingC 0.6s 0.3s linear infinite; }
  
    @keyframes loadingC {
        0 { transform: translate(0, 0); }
        50% { transform: translate(0, 15px); }
        100% { transform: translate(0, 0); }
    } 
    @keyframes loadingJ {
        0%, 100% { transform: translate(0, 0); }
        50% { transform: translate(80px, 0); background-color: #f5634a; width: 25px; }
    }
  
    & .line {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 10px;
        background-color: rgba(0,0,0,0.3);
    }
    &.hasMsg {
        transform: scale(0.5);
        margin-top: -5px;
    }
`)
